export const HIVE_BORDER_RADIUS_NONE = '0px';
export const HIVE_BORDER_RADIUS_XXSM = '1px';
export const HIVE_BORDER_RADIUS_XSM = '2px';
export const HIVE_BORDER_RADIUS_SM = '4px';
export const HIVE_BORDER_RADIUS_MD = '8px';
export const HIVE_BORDER_RADIUS_LG = '12px';
export const HIVE_BORDER_RADIUS_XLG = '16px';
export const HIVE_BORDER_RADIUS_XXLG = '24px';
export const HIVE_BORDER_RADIUS_CIRCLE = '32px';
export const HIVE_SIZING_100 = '8px';
export const HIVE_SIZING_150 = '12px';
export const HIVE_SIZING_200 = '16px';
export const HIVE_SIZING_300 = '24px';
export const HIVE_SIZING_400 = '32px';
export const HIVE_SIZING_500 = '40px';
export const HIVE_SIZING_600 = '48px';
export const HIVE_SIZING_700 = '56px';
export const HIVE_SIZING_800 = '64px';
export const HIVE_SIZING_900 = '72px';
export const HIVE_SIZING_1000 = '80px';
export const HIVE_SIZING_1200 = '96px';
export const HIVE_SIZING_1600 = '128px';
export const HIVE_SIZING_3200 = '256px';
export const HIVE_SIZING_4000 = '320px';
export const HIVE_SIZING_6400 = '512px';
export const HIVE_SPACING_NONE = '0px';
export const HIVE_SPACING_XXXXSM = '2px';
export const HIVE_SPACING_XXXSM = '4px';
export const HIVE_SPACING_XXSM = '8px';
export const HIVE_SPACING_XSM = '12px';
export const HIVE_SPACING_SM = '16px';
export const HIVE_SPACING_MD = '24px';
export const HIVE_SPACING_LG = '32px';
export const HIVE_SPACING_XLG = '40px';
export const HIVE_SPACING_XXLG = '64px';
export const HIVE_SPACING_XXXLG = '80px';
export const HIVE_SPACING_XXXXLG = '96px';
export const HIVE_BORDER_WIDTH_NONE = '0.0010px';
export const HIVE_BORDER_WIDTH_SM = '1px';
export const HIVE_BORDER_WIDTH_MD = '2px';
export const HIVE_BORDER_WIDTH_LG = '4px';
export const HIVE_GRID_GRID_BREAKPOINT_MIN_WIDTH = '1279px';
export const HIVE_GRID_GRID_MARGIN = '16px';
export const HIVE_GRID_GRID_BODY_PADDING_TOP = '16px';
export const HIVE_GRID_GRID_GUTTER = '16px';
export const HIVE_GRID_GRID_COLUMNS = '12px';
export const HIVE_GRID_GRID_HEADER_SIZE = 'Level 4';
export const HIVE_GRID_COLUMN_SIZES_LEFT_NAV_SCREEN_1_COL = '68px';
export const HIVE_GRID_COLUMN_SIZES_LEFT_NAV_SCREEN_2_COL = '152px';
export const HIVE_GRID_COLUMN_SIZES_LEFT_NAV_SCREEN_3_COL = '236px';
export const HIVE_GRID_COLUMN_SIZES_LEFT_NAV_SCREEN_4_COL = '320px';
export const HIVE_GRID_COLUMN_SIZES_LEFT_NAV_SCREEN_5_COL = '404px';
export const HIVE_GRID_COLUMN_SIZES_LEFT_NAV_SCREEN_6_COL = '488px';
export const HIVE_GRID_COLUMN_SIZES_LEFT_NAV_SCREEN_7_COL = '572px';
export const HIVE_GRID_COLUMN_SIZES_LEFT_NAV_SCREEN_8_COL = '656px';
export const HIVE_GRID_COLUMN_SIZES_LEFT_NAV_SCREEN_9_COL = '740px';
export const HIVE_GRID_COLUMN_SIZES_LEFT_NAV_SCREEN_10_COL = '824px';
export const HIVE_GRID_COLUMN_SIZES_LEFT_NAV_SCREEN_11_COL = '908px';
export const HIVE_GRID_COLUMN_SIZES_LEFT_NAV_SCREEN_12_COL = '992px';
export const HIVE_GRID_COLUMN_SIZES_FULL_SCREEN_1_COL = '89px';
export const HIVE_GRID_COLUMN_SIZES_FULL_SCREEN_2_COL = '195px';
export const HIVE_GRID_COLUMN_SIZES_FULL_SCREEN_3_COL = '300px';
export const HIVE_GRID_COLUMN_SIZES_FULL_SCREEN_4_COL = '404px';
export const HIVE_GRID_COLUMN_SIZES_FULL_SCREEN_5_COL = '511px';
export const HIVE_GRID_COLUMN_SIZES_FULL_SCREEN_6_COL = '616px';
export const HIVE_GRID_COLUMN_SIZES_FULL_SCREEN_7_COL = '721px';
export const HIVE_GRID_COLUMN_SIZES_FULL_SCREEN_8_COL = '827px';
export const HIVE_GRID_COLUMN_SIZES_FULL_SCREEN_9_COL = '932px';
export const HIVE_GRID_COLUMN_SIZES_FULL_SCREEN_10_COL = '1037px';
export const HIVE_GRID_COLUMN_SIZES_FULL_SCREEN_11_COL = '1143px';
export const HIVE_GRID_COLUMN_SIZES_FULL_SCREEN_12_COL = '1248px';
export const RED_100 = '#FFF1F0';
export const RED_200 = '#FFE4E0';
export const RED_300 = '#FFB6AD';
export const RED_400 = '#FF7B6C';
export const RED_500 = '#FF4747';
export const RED_600 = '#DB1616';
export const RED_700 = '#AC0404';
export const RED_800 = '#830707';
export const RED_900 = '#551711';
export const GREEN_100 = '#E4FFF9';
export const GREEN_200 = '#C8FFE7';
export const GREEN_300 = '#94EDC7';
export const GREEN_400 = '#69DFAD';
export const GREEN_500 = '#43C68F';
export const GREEN_600 = '#269F6C';
export const GREEN_700 = '#127D50';
export const GREEN_800 = '#09623C';
export const GREEN_900 = '#03472A';
export const BLUE_100 = '#F0FDFF';
export const BLUE_200 = '#CFF8FF';
export const BLUE_300 = '#88E6FF';
export const BLUE_400 = '#6BD6FF';
export const BLUE_500 = '#3ABDFF';
export const BLUE_600 = '#2A94DB';
export const BLUE_700 = '#1D70B7';
export const BLUE_800 = '#124F93';
export const BLUE_900 = '#0B387A';
export const ORANGE_100 = '#FFF9EB';
export const ORANGE_200 = '#FFEFC8';
export const ORANGE_300 = '#FFE7A9';
export const ORANGE_400 = '#FFCF73';
export const ORANGE_500 = '#FABC44';
export const ORANGE_600 = '#F4A32A';
export const ORANGE_700 = '#D18411';
export const ORANGE_800 = '#9C5F03';
export const ORANGE_900 = '#7C3C02';
export const GREY_100 = '#F8F8F8';
export const GREY_200 = '#F2F0F1';
export const GREY_300 = '#E3DDDF';
export const GREY_400 = '#D3CDD0';
export const GREY_500 = '#C0B9BC';
export const GREY_600 = '#ADA6A9';
export const GREY_700 = '#9B9195';
export const GREY_800 = '#7B6F74';
export const GREY_900 = '#5A4F54';
export const GREY_950 = '#3F3D3E';
export const RASPBERRY_100 = '#FFF6F8';
export const PLUM_PERFECTION_100 = '#F4EAF5';
export const PLUM_PERFECTION_200 = '#E9D5EC';
export const PLUM_PERFECTION_300 = '#DDC0E2';
export const PLUM_PERFECTION_400 = '#D2ABD9';
export const PLUM_PERFECTION_500 = '#C796CF';
export const PLUM_PERFECTION_600 = '#BC81C5';
export const PLUM_PERFECTION_700 = '#B16CBC';
export const PLUM_PERFECTION_800 = '#A557B2';
export const PLUM_PERFECTION_900 = '#9A42A9';
export const PLUM_PERFECTION_1000 = '#8F2D9F';
export const RASPBERRY_200 = '#FDC1CA';
export const RASPBERRY_300 = '#F76F87';
export const RASPBERRY_400 = '#F04A79';
export const RASPBERRY_500 = '#E61363';
export const RASPBERRY_600 = '#C50D65';
export const RASPBERRY_700 = '#A50963';
export const RASPBERRY_800 = '#750244';
export const RASPBERRY_900 = '#5A0031';
export const RASPBERRY_1000 = '#2B0016';
export const GREY_1000 = '#2F2F2F';
export const RED_1000 = '#27130C';
export const ORANGE_1000 = '#4D2500';
export const GREEN_1000 = '#011D07';
export const BLUE_1000 = '#06306D';
export const LIGHT = '#FFFFFF';
export const DARK = '#000000';
export const BLUEBERRY_BURST_100 = '#E9EDF8';
export const BLUEBERRY_BURST_200 = '#D4DBF1';
export const BLUEBERRY_BURST_300 = '#BEC9EA';
export const BLUEBERRY_BURST_400 = '#A8B7E3';
export const BLUEBERRY_BURST_500 = '#92A5DD';
export const BLUEBERRY_BURST_600 = '#7D94D6';
export const BLUEBERRY_BURST_700 = '#6782CF';
export const BLUEBERRY_BURST_800 = '#6782CF';
export const BLUEBERRY_BURST_900 = '#3C5EC1';
export const BLUEBERRY_BURST_1000 = '#264CBA';
export const ORANGE_TWIST_100 = '#FDF1EE';
export const ORANGE_TWIST_200 = '#FAE4DD';
export const ORANGE_TWIST_300 = '#F8D6CB';
export const ORANGE_TWIST_400 = '#F6C9BA';
export const ORANGE_TWIST_500 = '#F3BBA9';
export const ORANGE_TWIST_600 = '#F1AE98';
export const ORANGE_TWIST_700 = '#EFA087';
export const ORANGE_TWIST_800 = '#ED9375';
export const ORANGE_TWIST_900 = '#EA8564';
export const ORANGE_TWIST_1000 = '#E87853';
export const MAGENTA_MELON_100 = '#FAEAF1';
export const MAGENTA_MELON_200 = '#F4D5E4';
export const MAGENTA_MELON_300 = '#EFBFD6';
export const MAGENTA_MELON_400 = '#E9AAC9';
export const MAGENTA_MELON_500 = '#E495BB';
export const MAGENTA_MELON_600 = '#DF80AD';
export const MAGENTA_MELON_700 = '#D96BA0';
export const MAGENTA_MELON_800 = '#D45592';
export const MAGENTA_MELON_900 = '#CD347E';
export const MAGENTA_MELON_1000 = '#C92B77';
export const BLACKBERRY_SHADOW_100 = '#EEF5F8';
export const BLACKBERRY_SHADOW_200 = '#DEEBF1';
export const BLACKBERRY_SHADOW_300 = '#CDE1E9';
export const BLACKBERRY_SHADOW_400 = '#BDD7E2';
export const BLACKBERRY_SHADOW_500 = '#ACCDDB';
export const BLACKBERRY_SHADOW_600 = '#9BC2D4';
export const BLACKBERRY_SHADOW_700 = '#8BB8CD';
export const BLACKBERRY_SHADOW_800 = '#7AAEC5';
export const BLACKBERRY_SHADOW_900 = '#6AA4BE';
export const BLACKBERRY_SHADOW_1000 = '#599AB7';
export const LEMON_NEST_100 = '#FEF9EC';
export const LEMON_NEST_200 = '#FEF4D9';
export const LEMON_NEST_300 = '#FDEEC6';
export const LEMON_NEST_400 = '#FDE8B3';
export const LEMON_NEST_500 = '#FCE3A0';
export const LEMON_NEST_600 = '#FBDD8E';
export const LEMON_NEST_700 = '#FBD77B';
export const LEMON_NEST_800 = '#FAD168';
export const LEMON_NEST_900 = '#FACC55';
export const LEMON_NEST_1000 = '#F9C642';
export const TEAL_BERRY_100 = '#F2F9FB';
export const CLEMENTINE_100 = '#FFF9EB';
export const CLEMENTINE_200 = '#FFD5B2';
export const CLEMENTINE_300 = '#FFAA64';
export const CLEMENTINE_400 = '#FA782E';
export const CLEMENTINE_500 = '#FE5000';
export const CLEMENTINE_600 = '#CC4000';
export const CLEMENTINE_700 = '#993000';
export const CLEMENTINE_800 = '#8E360E';
export const CLEMENTINE_900 = '#5F1F01';
export const CLEMENTINE_1000 = '#481701';
export const TEAL_BERRY_200 = '#E6F4F8';
export const TEAL_BERRY_300 = '#D9EEF4';
export const TEAL_BERRY_400 = '#CCE8F1';
export const TEAL_BERRY_500 = '#BFE3ED';
export const TEAL_BERRY_600 = '#B3DDE9';
export const TEAL_BERRY_700 = '#A6D7E6';
export const TEAL_BERRY_800 = '#99D1E2';
export const TEAL_BERRY_900 = '#8DCCDF';
export const TEAL_BERRY_1000 = '#80C6DB';
export const PURE_SAND_100 = '#FAF7F1';
export const PURE_SAND_200 = '#F3EAD8';
export const PURE_SAND_300 = '#E8DABF';
export const PURE_GREY_100 = '#F8F8F8';
export const PURE_GREY_200 = '#EDEDED';
export const PURE_GREY_300 = '#DADADA';
export const PURE_GREY_400 = '#B5B5B5';
export const PURE_GREY_500 = '#909090';
export const PURE_GREY_600 = '#6C6C6C';
export const PURE_GREY_700 = '#474747';
export const PURE_GREY_800 = '#2C2C2C';
export const PURE_GREY_900 = '#1C1C1C';
export const PURE_GREY_1000 = '#0F0F0F';
export const PURE_HONEY_300 = '#FDDF8D';
export const PURE_HONEY_400 = '#FBD170';
export const PURE_HONEY_500 = '#F9BC42';
export const PURE_HONEY_600 = '#D69930';
export const PURE_HONEY_700 = '#B37821';
export const PURE_SLATE_300 = '#6BB6CB';
export const PURE_SLATE_400 = '#3E7E97';
export const PURE_SLATE_500 = '#123C52';
export const PURE_SLATE_600 = '#0D2F46';
export const PURE_SLATE_700 = '#09233B';
export const PURE_ICE_300 = '#CFFFFE';
export const PURE_ICE_400 = '#C9F5F9';
export const PURE_ICE_500 = '#B8EDF7';
export const PURE_ICE_600 = '#80C6DB';
export const PURE_ICE_700 = '#589AB7';
export const PURE_GREEN_100 = '#EAFCE1';
export const PURE_GREEN_200 = '#D0FAC4';
export const PURE_GREEN_300 = '#AEF1A3';
export const PURE_GREEN_400 = '#8CE487';
export const PURE_GREEN_500 = '#61D365';
export const PURE_GREEN_600 = '#46B554';
export const PURE_GREEN_700 = '#309746';
export const PURE_GREEN_800 = '#1E7A3A';
export const PURE_GREEN_900 = '#126532';
export const PURE_BLUE_100 = '#D7FBFF';
export const PURE_BLUE_200 = '#B0F3FF';
export const PURE_BLUE_300 = '#88E6FF';
export const PURE_BLUE_400 = '#6BD6FF';
export const PURE_BLUE_500 = '#3ABDFF';
export const PURE_BLUE_600 = '#2A94DB';
export const PURE_BLUE_700 = '#1D70B7';
export const PURE_BLUE_800 = '#124F93';
export const PURE_BLUE_900 = '#0B387A';
export const PURE_RED_100 = '#FEE2DA';
export const PURE_RED_200 = '#FDC0B6';
export const PURE_RED_300 = '#F99590';
export const PURE_RED_400 = '#F37379';
export const PURE_RED_500 = '#EC475E';
export const PURE_RED_600 = '#CA3356';
export const PURE_RED_700 = '#A9234F';
export const PURE_RED_800 = '#881646';
export const PURE_RED_900 = '#881646';
export const PURE_YELLOW_100 = '#FEFCD8';
export const PURE_YELLOW_200 = '#FDF8B2';
export const PURE_YELLOW_300 = '#FBF28B';
export const PURE_YELLOW_400 = '#F8EC6E';
export const PURE_YELLOW_500 = '#F4E23F';
export const PURE_YELLOW_600 = '#D1BF2E';
export const PURE_YELLOW_700 = '#D1BF2E';
export const PURE_YELLOW_800 = '#8D7D14';
export const PURE_YELLOW_900 = '#75660C';
export const PURE_ECO_400 = '#8FBC55';
export const PURE_ECO_500 = '#65954E';
export const PURE_ECO_600 = '#3D7307';
export const PURE_ECO_700 = '#0A5103';
export const PURE_ECO_800 = '#063F00';
export const HIVE_FONT_FAMILY_INTER = 'Inter';
export const HIVE_FONT_SIZE_XXXSM = '9px';
export const HIVE_FONT_SIZE_XXSM = '11px';
export const HIVE_FONT_SIZE_XSM = '12px';
export const HIVE_FONT_SIZE_SM = '14px';
export const HIVE_FONT_SIZE_BASE = '16px';
export const HIVE_FONT_SIZE_MD = '18px';
export const HIVE_FONT_SIZE_LG = '20px';
export const HIVE_FONT_SIZE_XLG = '22px';
export const HIVE_FONT_SIZE_XXLG = '26px';
export const HIVE_FONT_SIZE_XXXLG = '29px';
export const HIVE_FONT_SIZE_XXXXLG = '32px';
export const HIVE_FONT_WEIGHT_100 = '100';
export const HIVE_FONT_DECORATION_REGULAR = 'Regular';
export const HIVE_FONT_DECORATION_ITALIC = 'Italic';
export const HIVE_FONT_WEIGHT_300 = '300';
export const HIVE_FONT_WEIGHT_400 = '400';
export const HIVE_FONT_WEIGHT_600 = '600';
export const HIVE_FONT_WEIGHT_700 = '700';
export const HIVE_FONT_WEIGHT_800 = '800';
export const HIVE_FONT_LETTER_SPACING_MEDIUM = '0px';
export const HIVE_FONT_LETTER_SPACING_LARGE = '0.4000px';
export const ASSISTIVE_CONTENT = '12px';
export const FIELD_VALUE_REGULAR = '12px';
export const FIELD_VALUE_ITALIC = '12px';
export const HEADING_LEVEL_1 = '29px';
export const HEADING_LEVEL_2 = '26px';
export const HEADING_LEVEL_3 = '22px';
export const HEADING_LEVEL_4 = '20px';
export const HEADING_LEVEL_5 = '18px';
export const HEADING_LEVEL_6 = '16px';
export const FREE_FLOW_CONTENT_SMALLEST_REGULAR = '9px';
export const FREE_FLOW_CONTENT_SMALLEST_SEMIBOLD = '9px';
export const FREE_FLOW_CONTENT_SMALLEST_BOLD = '9px';
export const FREE_FLOW_CONTENT_SMALL_REGULAR = '12px';
export const FREE_FLOW_CONTENT_SMALL_SEMIBOLD = '12px';
export const FREE_FLOW_CONTENT_SMALL_BOLD = '12px';
export const FREE_FLOW_CONTENT_MEDIUM_REGULAR = '14px';
export const FREE_FLOW_CONTENT_MEDIUM_SEMIBOLD = '14px';
export const FREE_FLOW_CONTENT_MEDIUM_BOLD = '14px';
export const FREE_FLOW_CONTENT_LARGE_REGULAR = '16px';
export const FREE_FLOW_CONTENT_LARGE_SEMIBOLD = '16px';
export const FREE_FLOW_CONTENT_LARGE_BOLD = '16px';
export const LABEL_SMALLEST_SEMIBOLD = '9px';
export const LABEL_SMALLEST_BOLD = '9px';
export const LABEL_SMALLEST_REGULAR = '9px';
export const LABEL_SMALL_REGULAR = '12px';
export const LABEL_SMALL_SEMIBOLD = '12px';
export const LABEL_SMALL_BOLD = '12px';
export const LABEL_MEDIUM_REGULAR = '14px';
export const LABEL_MEDIUM_SEMIBOLD = '14px';
export const LABEL_MEDIUM_BOLD = '14px';
export const LABEL_LARGE_REGULAR = '16px';
export const LABEL_LARGE_SEMIBOLD = '16px';
export const LABEL_LARGE_BOLD = '16px';
export const VALUE_SMALL_REGULAR = '12px';
export const VALUE_SMALL_SEMIBOLD = '12px';
export const VALUE_MEDIUM_REGULAR = '14px';
export const VALUE_MEDIUM_SEMIBOLD = '14px';
export const VALUE_LARGE_REGULAR = '22px';
export const VALUE_LARGE_SEMIBOLD = '22px';
export const VALUE_EXTRA_LARGE_REGULAR = '32px';
export const VALUE_EXTRA_LARGE_SEMIBOLD = '32px';
export const LINK_SMALLEST_REGULAR = '9px';
export const LINK_SMALLEST_UNDERLINE = '9px';
export const LINK_SMALL_REGULAR = '12px';
export const LINK_SMALL_UNDERLINE = '12px';
export const LINK_MEDIUM_REGULAR = '14px';
export const LINK_MEDIUM_UNDERLINE = '14px';
export const LINK_LARGE_REGULAR = '16px';
export const LINK_LARGE_UNDERLINE = '16px';
export const HIVE_BACKGROUND_BASE = '#F8F8F8';
export const HIVE_BACKGROUND_SURFACE = '#FFFFFF';
export const HIVE_BACKGROUND_INVERTED = '#2F2F2F';
export const HIVE_BACKGROUND_ACCENT = '#5A0031';
export const HIVE_BACKGROUND_ACCENT_HOVER = '#2B0016';
export const HIVE_BACKGROUND_ACCENT_PRESSED = '#5A0031';
export const HIVE_BACKGROUND_ACCENT_MEDIUM_HOVER = '#A50963';
export const HIVE_BACKGROUND_ACCENT_SUBTLE_HOVER = '#F2F0F1';
export const HIVE_BACKGROUND_ACCENT_SUBTLE_SELECTED = '#E3DDDF';
export const HIVE_BACKGROUND_NEUTRAL_SUBTLEST = '#F8F8F8';
export const HIVE_BACKGROUND_ACCENT_SUBTLEST_HOVER = '#FFF6F8';
export const HIVE_BACKGROUND_ACCENT_SELECTED = '#2B0016';
export const HIVE_BACKGROUND_INVERTED_ACCENT_HOVER = '#E3DDDF';
export const HIVE_BACKGROUND_INVERTED_ACCENT_PRESSED = '#C0B9BC';
export const HIVE_BACKGROUND_INVERTED_ACCENT_SELECTED = '#C0B9BC';
export const HIVE_BACKGROUND_INVERTED_SUBTLE_HOVER = '#5A4F54';
export const HIVE_BACKGROUND_INVERTED_SUBTLE_PRESSED = '#3F3D3E';
export const HIVE_BACKGROUND_INVERTED_SUBTLE_SELECTED = '#3F3D3E';
export const HIVE_BACKGROUND_INVERTED_ACCENT = '#F8F8F8';
export const HIVE_BACKGROUND_INVERTED_DISABLED = '#5A4F54';
export const HIVE_BACKGROUND_NEUTRAL_SUBTLE = '#E3DDDF';
export const HIVE_BACKGROUND_NEUTRAL_MEDIUM = '#C0B9BC';
export const HIVE_BACKGROUND_NEUTRAL_BOLD = '#9B9195';
export const HIVE_BACKGROUND_NEUTRAL_BOLDER = '#2F2F2F';
export const HIVE_BACKGROUND_NEUTRAL_SELECTED = '#F8F8F8';
export const HIVE_BACKGROUND_DANGER_BOLD_HOVER = '#AC0404';
export const HIVE_BACKGROUND_DANGER_BOLD_PRESSED = '#830707';
export const HIVE_BACKGROUND_DANGER_BOLD_SELECTED = '#AC0404';
export const HIVE_BACKGROUND_DANGER_TERTIARY_HOVER = '#FFE4E0';
export const HIVE_BACKGROUND_DISABLED_PRIMARY = '#D3CDD0';
export const HIVE_BACKGROUND_DISABLED_SECONDARY = '#F8F8F8';
export const HIVE_BACKGROUND_DANGER_SUBTLEST = '#FFF1F0';
export const HIVE_BACKGROUND_DANGER_SUBTLE = '#FFB6AD';
export const HIVE_BACKGROUND_DANGER_BOLD = '#DB1616';
export const HIVE_BACKGROUND_SUCCESS_SUBTLEST = '#E4FFF9';
export const HIVE_BACKGROUND_SUCCESS_SUBTLE = '#94EDC7';
export const HIVE_BACKGROUND_SUCCESS_BOLD = '#269F6C';
export const HIVE_BACKGROUND_WARNING_SUBTLEST = '#FFF9EB';
export const HIVE_BACKGROUND_WARNING_SUBTLE = '#FFE7A9';
export const HIVE_BACKGROUND_WARNING_BOLD = '#F4A32A';
export const HIVE_BACKGROUND_INFO_SUBTLEST = '#F0FDFF';
export const HIVE_BACKGROUND_INFO_SUBTLE = '#88E6FF';
export const HIVE_BACKGROUND_INFO_BOLD = '#2A94DB';
export const HIVE_TEXT_INVERTED_PRIMARY = '#F8F8F8';
export const HIVE_TEXT_INVERTED_DISABLED = '#7B6F74';
export const HIVE_TEXT_ACCENT_PRIMARY = '#5A0031';
export const HIVE_TEXT_ACCENT_SECONDARY = '#750244';
export const HIVE_TEXT_ACCENT_BOLDER = '#2B0016';
export const HIVE_TEXT_SUCCESS_HOVER = '#127D50';
export const HIVE_TEXT_SUCCESS_PRESSED = '#011D07';
export const HIVE_TEXT_INFO_PRESSED = '#06306D';
export const HIVE_TEXT_INFO_DISABLED = '#7B6F74';
export const HIVE_TEXT_WARNING_HOVER = '#9C5F03';
export const HIVE_TEXT_DANGER_HOVER = '#DB1616';
export const HIVE_TEXT_DANGER_PRESSED = '#551711';
export const HIVE_TEXT_WARNING_PRESSED = '#7C3C02';
export const HIVE_TEXT_ONINVERTED_PRIMARY = '#F8F8F8';
export const HIVE_TEXT_ONINVERTED_SECONDARY = '#3F3D3E';
export const HIVE_TEXT_ONINVERTED_DISABLED = '#9B9195';
export const HIVE_TEXT_ONNEUTRAL_PRIMARY = '#5A4F54';
export const HIVE_TEXT_ONNEUTRAL_SECONDARY = '#2F2F2F';
export const HIVE_TEXT_ONACCENT_PRIMARY = '#FFF6F8';
export const HIVE_TEXT_ONACCENT_SECONDARY = '#FDC1CA';
export const HIVE_TEXT_ONACCENT_TERTIARY = '#5A0031';
export const HIVE_TEXT_ONACCENT_PRESSED = '#2B0016';
export const HIVE_TEXT_PRIMARY = '#5A4F54';
export const HIVE_TEXT_SECONDARY = '#7B6F74';
export const HIVE_TEXT_TERTIARY = '#D3CDD0';
export const HIVE_TEXT_DISABLED = '#C0B9BC';
export const HIVE_TEXT_SUCCESS = '#269F6C';
export const HIVE_TEXT_WARNING = '#D18411';
export const HIVE_TEXT_DANGER = '#DB1616';
export const HIVE_TEXT_INFO = '#1D70B7';
export const HIVE_TEXT_ONSUCCESS = '#03472A';
export const HIVE_TEXT_ONWARNING = '#4D2500';
export const HIVE_TEXT_ONDANGER_PRIMARY = '#FFF1F0';
export const HIVE_TEXT_ONDANGER_SECONDARY = '#DB1616';
export const HIVE_TEXT_ONDANGER_TERTIARY = '#830707';
export const HIVE_TEXT_ONINFO = '#0B387A';
export const HIVE_BORDER_ACCENT_PRIMARY = '#5A0031';
export const HIVE_BORDER_ACCENT_SECONDARY = '#750244';
export const HIVE_TEXT_ONDISABLED_BOLD = '#9B9195';
export const HIVE_BORDER_ACCENT_TERTIARY = '#A50963';
export const HIVE_TEXT_ONDISABLED_MEDIUM = '#C0B9BC';
export const HIVE_BORDER_DISABLED_MEDIUM = '#D3CDD0';
export const HIVE_BORDER_INVERTED_BOLDER = '#F8F8F8';
export const HIVE_BORDER_INVERTED_DISABLED = '#7B6F74';
export const HIVE_BORDER_DISABLED_BOLD = '#ADA6A9';
export const HIVE_BORDER_NEUTRAL_SUBTLEST = '#F8F8F8';
export const HIVE_BORDER_NEUTRAL_SUBTLE = '#E3DDDF';
export const HIVE_BORDER_NEUTRAL_MEDIUM = '#D3CDD0';
export const HIVE_BORDER_NEUTRAL_BOLD = '#9B9195';
export const HIVE_BORDER_NEUTRAL_BOLDER = '#3F3D3E';
export const HIVE_BORDER_ACCENT_BOLD_HOVER = '#750244';
export const HIVE_BORDER_ACCENT_BOLD_SELECTED = '#2B0016';
export const HIVE_BORDER_SUCCESS_SUBTLE = '#94EDC7';
export const HIVE_BORDER_SUCCESS_BOLD = '#127D50';
export const HIVE_BORDER_WARNING_SUBTLE = '#FFE7A9';
export const HIVE_BORDER_DANGER_SUBTLE = '#FFB6AD';
export const HIVE_BORDER_DANGER_MEDIUM = '#DB1616';
export const HIVE_BORDER_DANGER_BOLD = '#AC0404';
export const HIVE_BORDER_DANGER_SELECTED = '#830707';
export const HIVE_BORDER_INFO_SUBTLE = '#88E6FF';
export const HIVE_FOCUS_OUTLINE_FOCUS_OUTLINE = '#750244';
export const HIVE_FOCUS_OUTLINE_FOCUS_OUTLINE_INVERSE = '#FFF6F8';
export const HIVE_APPBAR_BACKGROUND = '#2F2F2F';
export const HIVE_APPBAR_TEXT_DEFAULT = '#F8F8F8';
export const HIVE_APPNAVIGATION_SURFACE = '#FFFFFF';
export const HIVE_APPNAVIGATION_TEXT_DEFAULT = '#5A4F54';
export const HIVE_APPNAVIGATION_TEXT_HOVER = '#5A4F54';
export const HIVE_APPNAVIGATION_TEXT_PRESSED = '#5A4F54';
export const HIVE_APPNAVIGATION_TEXT_DISABLED = '#C0B9BC';
export const HIVE_APPNAVIGATION_TEXT_SELECTED = '#750244';
export const HIVE_APPNAVIGATION_TEXT_OPENED = '#5A4F54';
export const HIVE_APPNAVIGATION_ICONS_DEFAULT = '#7B6F74';
export const HIVE_APPNAVIGATION_ICONS_HOVER = '#7B6F74';
export const HIVE_APPNAVIGATION_ICONS_PRESSED = '#7B6F74';
export const HIVE_APPNAVIGATION_ICONS_DISABLED = '#ADA6A9';
export const HIVE_APPNAVIGATION_ICONS_SELECTED = '#750244';
export const HIVE_APPNAVIGATION_ICONS_OPENED = '#5A4F54';
export const HIVE_APPNAVIGATION_ITEMBG_DEFAULT = '#FFFFFF';
export const HIVE_APPNAVIGATION_ITEMBG_HOVER = '#FFF6F8';
export const HIVE_APPNAVIGATION_ITEMBG_PRESSED = '#FFF6F8';
export const HIVE_APPNAVIGATION_ITEMBG_DISABLED = '#FFFFFF';
export const HIVE_APPNAVIGATION_ITEMBG_SELECTED = '#F8F8F8';
export const HIVE_APPNAVIGATION_ITEMBG_OPENED = '#FFFFFF';
export const HIVE_APPDROPDOWN_BACKGROUND_HOVER = '#5A4F54';
export const HIVE_LINK_DEFAULT_DEFAULT = '#1D70B7';
export const HIVE_LINK_DEFAULT_PRESSED = '#06306D';
export const HIVE_LINK_DEFAULT_DISABLED = '#C0B9BC';
export const HIVE_LINK_DEFAULT_VISITED = '#06306D';
export const HIVE_APPDROPDOWN_BACKGROUND_SELECTED = '#3F3D3E';
export const HIVE_APPDROPDOWN_TEXT_DEFAULT = '#F8F8F8';
export const HIVE_APPDROPDOWN_TEXT_DISABLED = '#7B6F74';
export const HIVE_TAB_BACKGROUND_HOVER = '#F2F0F1';
export const HIVE_TAB_TEXT_DEFAULT = '#5A4F54';
export const HIVE_TAB_TEXT_ACTIVE = '#750244';
export const HIVE_INTERACTIVECARD_BACKGROUND_HOVER = '#FFF6F8';
export const HIVE_INTERACTIVECARD_TEXT_SELECTED = '#750244';
export const HIVE_INTERACTIVECARD_BORDER_DEFAULT = '#E3DDDF';
export const HIVE_TAB_BORDER_DEFAULT = '#750244';
export const HIVE_AI_BACKGROUND_START = '#F4A32A';
export const HIVE_AI_BACKGROUND_END = '#E61363';
export const HIVE_AI_TEXT_ONBACKGROUND = '#F8F8F8';
export const HIVE_AI_TEXT_DEFAULT = '#C50D65';
export const HIVE_DATAVIZ_CATEGORY_1 = '#8F2D9F';
export const HIVE_DATAVIZ_CATEGORY_2 = '#264CBA';
export const HIVE_DATAVIZ_CATEGORY_3 = '#E87853';
export const HIVE_DATAVIZ_CATEGORY_4 = '#C92B77';
export const HIVE_DATAVIZ_CATEGORY_5 = '#599AB7';
export const HIVE_DATAVIZ_CATEGORY_6 = '#F9C642';
export const HIVE_DATAVIZ_CATEGORY_7 = '#80C6DB';
export const HIVE_DATAVIZ_CATEGORY_8 = '#A557B2';
export const HIVE_DATAVIZ_CATEGORY_9 = '#6782CF';
export const HIVE_DATAVIZ_CATEGORY_10 = '#ED9375';
export const HIVE_DATAVIZ_STATUS_DANGER_MEDIUM_PRIMARY = '#FF4747';
export const HIVE_DATAVIZ_STATUS_DANGER_MEDIUM_SECONDARY = '#FFB6AD';
export const HIVE_DATAVIZ_STATUS_DANGER_MEDIUM_TERTIARY = '#FFF1F0';
export const HIVE_DATAVIZ_MONOCHROMATIC_1_1 = '#8F2D9F';
export const HIVE_DATAVIZ_MONOCHROMATIC_1_2 = '#A557B2';
export const HIVE_DATAVIZ_MONOCHROMATIC_1_3 = '#BC81C5';
export const HIVE_DATAVIZ_MONOCHROMATIC_1_4 = '#D2ABD9';
export const HIVE_DATAVIZ_MONOCHROMATIC_1_5 = '#E9D5EC';
export const HIVE_DATAVIZ_MONOCHROMATIC_1_6 = '#9A42A9';
export const HIVE_DATAVIZ_MONOCHROMATIC_1_7 = '#B16CBC';
export const HIVE_DATAVIZ_MONOCHROMATIC_1_8 = '#C796CF';
export const HIVE_DATAVIZ_MONOCHROMATIC_1_9 = '#DDC0E2';
export const HIVE_DATAVIZ_MONOCHROMATIC_1_10 = '#F4EAF5';
export const HIVE_DATAVIZ_STATUS_ADVANCED = '#6AA4BE';
export const HIVE_DATAVIZ_STATUS_SUCCESS_MEDIUM_PRIMARY = '#43C68F';
export const HIVE_DATAVIZ_STATUS_SUCCESS_MEDIUM_SECONDARY = '#94EDC7';
export const HIVE_DATAVIZ_STATUS_SUCCESS_MEDIUM_TERTIARY = '#E4FFF9';
export const HIVE_DATAVIZ_STATUS_WARNING_MEDIUM_PRIMARY = '#FABC44';
export const HIVE_DATAVIZ_STATUS_WARNING_MEDIUM_SECONDARY = '#FFE7A9';
export const HIVE_DATAVIZ_STATUS_WARNING_MEDIUM_TERTIARY = '#FFF9EB';
export const HIVE_DATAVIZ_STATUS_INFO_MEDIUM_PRIMARY = '#3ABDFF';
export const HIVE_DATAVIZ_STATUS_INFO_MEDIUM_SECONDARY = '#88E6FF';
export const HIVE_DATAVIZ_STATUS_INFO_MEDIUM_TERTIARY = '#F0FDFF';
export const HIVE_DATAVIZ_STATUS_INPROGRESS = '#7B6F74';
export const HIVE_DATAVIZ_STATUS_EXCLUDED = '#ADA6A9';
export const HIVE_BORDER_ACCENT_SUBTLE_HOVER = '#A50963';
export const HIVE_BORDER_ACCENT_SUBTLE_PRESSED = '#5A0031';
export const HIVE_BORDER_ACCENT_SUBTLE_SELECTED = '#5A0031';
export const HIVE_DATAVIZ_STATUS_DANGER_BOLD_PRIMARY = '#DB1616';
export const HIVE_DATAVIZ_STATUS_DANGER_BOLD_SECONDARY = '#FF7B6C';
export const HIVE_DATAVIZ_STATUS_DANGER_BOLD_TERTIARY = '#FFE4E0';
export const HIVE_DATAVIZ_STATUS_SUCCESS_BOLD_PRIMARY = '#269F6C';
export const HIVE_DATAVIZ_STATUS_SUCCESS_BOLD_SECONDARY = '#69DFAD';
export const HIVE_DATAVIZ_STATUS_SUCCESS_BOLD_TERTIARY = '#C8FFE7';
export const HIVE_DATAVIZ_STATUS_WARNING_BOLD_PRIMARY = '#F4A32A';
export const HIVE_DATAVIZ_STATUS_WARNING_BOLD_SECONDARY = '#FFCF73';
export const HIVE_DATAVIZ_STATUS_WARNING_BOLD_TERTIARY = '#FFEFC8';
export const HIVE_DATAVIZ_STATUS_INFO_BOLD_PRIMARY = '#2A94DB';
export const HIVE_DATAVIZ_STATUS_INFO_BOLD_SECONDARY = '#6BD6FF';
export const HIVE_DATAVIZ_STATUS_INFO_BOLD_TERTIARY = '#CFF8FF';
export const HIVE_LINK_INFO_DEFAULT = '#0B387A';
export const HIVE_LINK_INFO_PRESSED = '#06306D';
export const HIVE_LINK_INFO_DISABLED = '#7B6F74';
export const HIVE_LINK_INFO_VISITED = '#0B387A';
export const HIVE_LINK_INFO_HOVER = '#0B387A';
export const HIVE_LINK_SUCCESS_DEFAULT = '#03472A';
export const HIVE_LINK_SUCCESS_PRESSED = '#011D07';
export const HIVE_LINK_SUCCESS_DISABLED = '#7B6F74';
export const HIVE_LINK_SUCCESS_VISITED = '#03472A';
export const HIVE_LINK_SUCCESS_HOVER = '#03472A';
export const HIVE_LINK_WARNING_DEFAULT = '#7C3C02';
export const HIVE_LINK_WARNING_PRESSED = '#4D2500';
export const HIVE_LINK_WARNING_DISABLED = '#7B6F74';
export const HIVE_LINK_WARNING_VISITED = '#7C3C02';
export const HIVE_LINK_WARNING_HOVER = '#7C3C02';
export const HIVE_LINK_DANGER_DEFAULT = '#830707';
export const HIVE_LINK_DANGER_PRESSED = '#551711';
export const HIVE_LINK_DANGER_DISABLED = '#5A4F54';
export const HIVE_LINK_DANGER_VISITED = '#830707';
export const HIVE_LINK_DANGER_HOVER = '#830707';
export const HIVE_DATAVIZ_MONOCHROMATIC_2_1 = '#E87853';
export const HIVE_DATAVIZ_MONOCHROMATIC_2_2 = '#ED9375';
export const HIVE_DATAVIZ_MONOCHROMATIC_2_3 = '#F1AE98';
export const HIVE_DATAVIZ_MONOCHROMATIC_2_4 = '#F6C9BA';
export const HIVE_DATAVIZ_MONOCHROMATIC_2_5 = '#FAE4DD';
export const HIVE_DATAVIZ_MONOCHROMATIC_2_6 = '#EA8564';
export const HIVE_DATAVIZ_MONOCHROMATIC_2_7 = '#EFA087';
export const HIVE_DATAVIZ_MONOCHROMATIC_2_8 = '#F3BBA9';
export const HIVE_DATAVIZ_MONOCHROMATIC_2_9 = '#F8D6CB';
export const HIVE_DATAVIZ_MONOCHROMATIC_2_10 = '#FDF1EE';
export const HIVE_DATAVIZ_MONOCHROMATIC_3_1 = '#264CBA';
export const HIVE_DATAVIZ_MONOCHROMATIC_3_2 = '#6782CF';
export const HIVE_DATAVIZ_MONOCHROMATIC_3_3 = '#7D94D6';
export const HIVE_DATAVIZ_MONOCHROMATIC_3_4 = '#A8B7E3';
export const HIVE_DATAVIZ_MONOCHROMATIC_3_5 = '#D4DBF1';
export const HIVE_DATAVIZ_MONOCHROMATIC_3_6 = '#3C5EC1';
export const HIVE_DATAVIZ_MONOCHROMATIC_3_7 = '#6782CF';
export const HIVE_DATAVIZ_MONOCHROMATIC_3_8 = '#92A5DD';
export const HIVE_DATAVIZ_MONOCHROMATIC_3_9 = '#BEC9EA';
export const HIVE_DATAVIZ_MONOCHROMATIC_3_10 = '#E9EDF8';
export const HIVE_DATAVIZ_MONOCHROMATIC_4_1 = '#F9C642';
export const HIVE_DATAVIZ_MONOCHROMATIC_4_2 = '#FAD168';
export const HIVE_DATAVIZ_MONOCHROMATIC_4_3 = '#FBDD8E';
export const HIVE_DATAVIZ_MONOCHROMATIC_4_4 = '#FDE8B3';
export const HIVE_DATAVIZ_MONOCHROMATIC_4_5 = '#FEF4D9';
export const HIVE_DATAVIZ_MONOCHROMATIC_4_6 = '#FACC55';
export const HIVE_DATAVIZ_MONOCHROMATIC_4_7 = '#FBD77B';
export const HIVE_DATAVIZ_MONOCHROMATIC_4_8 = '#FCE3A0';
export const HIVE_DATAVIZ_MONOCHROMATIC_4_9 = '#FDEEC6';
export const HIVE_DATAVIZ_MONOCHROMATIC_4_10 = '#FEF9EC';
export const HIVE_DATAVIZ_MONOCHROMATIC_5_1 = '#C92B77';
export const HIVE_DATAVIZ_MONOCHROMATIC_5_2 = '#D45592';
export const HIVE_DATAVIZ_MONOCHROMATIC_5_3 = '#DF80AD';
export const HIVE_DATAVIZ_MONOCHROMATIC_5_4 = '#E9AAC9';
export const HIVE_DATAVIZ_MONOCHROMATIC_5_5 = '#F4D5E4';
export const HIVE_DATAVIZ_MONOCHROMATIC_5_6 = '#CD347E';
export const HIVE_DATAVIZ_MONOCHROMATIC_5_7 = '#D96BA0';
export const HIVE_DATAVIZ_MONOCHROMATIC_5_8 = '#E495BB';
export const HIVE_DATAVIZ_MONOCHROMATIC_5_9 = '#EFBFD6';
export const HIVE_DATAVIZ_MONOCHROMATIC_5_10 = '#FAEAF1';
export const HIVE_DATAVIZ_MONOCHROMATIC_6_1 = '#599AB7';
export const HIVE_DATAVIZ_MONOCHROMATIC_6_1_2 = '#599AB7';
export const HIVE_DATAVIZ_MONOCHROMATIC_6_2 = '#7AAEC5';
export const HIVE_DATAVIZ_MONOCHROMATIC_6_3 = '#9BC2D4';
export const HIVE_DATAVIZ_MONOCHROMATIC_6_4 = '#BDD7E2';
export const HIVE_DATAVIZ_MONOCHROMATIC_6_5 = '#DEEBF1';
export const HIVE_DATAVIZ_MONOCHROMATIC_6_6 = '#6AA4BE';
export const HIVE_DATAVIZ_MONOCHROMATIC_6_7 = '#8BB8CD';
export const HIVE_DATAVIZ_MONOCHROMATIC_6_8 = '#ACCDDB';
export const HIVE_DATAVIZ_MONOCHROMATIC_6_9 = '#CDE1E9';
export const HIVE_DATAVIZ_MONOCHROMATIC_6_10 = '#EEF5F8';
export const HIVE_DATAVIZ_MONOCHROMATIC_7_1 = '#80C6DB';
export const HIVE_DATAVIZ_MONOCHROMATIC_7_1_2 = '#80C6DB';
export const HIVE_DATAVIZ_MONOCHROMATIC_7_2 = '#99D1E2';
export const HIVE_DATAVIZ_MONOCHROMATIC_7_3 = '#B3DDE9';
export const HIVE_DATAVIZ_MONOCHROMATIC_7_4 = '#CCE8F1';
export const HIVE_DATAVIZ_MONOCHROMATIC_7_5 = '#E6F4F8';
export const HIVE_DATAVIZ_MONOCHROMATIC_7_6 = '#8DCCDF';
export const HIVE_DATAVIZ_MONOCHROMATIC_7_7 = '#A6D7E6';
export const HIVE_DATAVIZ_MONOCHROMATIC_7_8 = '#BFE3ED';
export const HIVE_DATAVIZ_MONOCHROMATIC_7_9 = '#D9EEF4';
export const HIVE_DATAVIZ_MONOCHROMATIC_7_10 = '#F2F9FB';
export const HIVE_LINK_INVERTED_DEFAULT = '#F8F8F8';
export const HIVE_LINK_INVERTED_PRESSED = '#F8F8F8';
export const HIVE_LINK_INVERTED_DISABLED = '#7B6F74';
export const HIVE_LINK_INVERTED_VISITED = '#F8F8F8';
export const HIVE_LINK_INVERTED_HOVER = '#F8F8F8';
export const HIVE_FIELDS_BACKGROUND_DEFAULT = '#FFFFFF';
export const HIVE_FIELDS_BACKGROUND_SUBTLE = '#F2F0F1';
export const HIVE_FIELDS_BACKGROUND_DANGER = '#FFF1F0';
export const HIVE_FIELDS_TEXT_DEFAULT = '#5A4F54';
export const HIVE_FIELDS_TEXT_PLACEHOLDER = '#9B9195';
export const HIVE_FIELDS_TEXT_ONDANGER = '#DB1616';
export const HIVE_FIELDS_TEXT_DISABLED = '#C0B9BC';
export const HIVE_FIELDS_BORDER_DEFAULT = '#9B9195';
export const HIVE_FIELDS_BORDER_DANGER = '#DB1616';
export const HIVE_FIELDS_BORDER_DISABLED = '#F2F0F1';
export const HIVE_FIELDS_ICONS_DEFAULT = '#9B9195';
export const HIVE_HEADING_SIZE_LEVEL_1 = '32px';
export const HIVE_HEADING_SIZE_LEVEL_2 = '29px';
export const HIVE_HEADING_SIZE_LEVEL_3 = '26px';
export const HIVE_HEADING_SIZE_LEVEL_4 = '22px';
export const HIVE_HEADING_SIZE_LEVEL_5 = '20px';
export const HIVE_HEADING_SIZE_LEVEL_6 = '18px';
export const HIVE_HEADING_WEIGHT_LEVEL_1 = '700';
export const HIVE_HEADING_WEIGHT_LEVEL_2 = '700';
export const HIVE_HEADING_WEIGHT_LEVEL_3 = '600';
export const HIVE_HEADING_WEIGHT_LEVEL_4 = '600';
export const HIVE_HEADING_WEIGHT_LEVEL_5 = '600';
export const HIVE_HEADING_WEIGHT_LEVEL_6 = '600';
export const HIVE_HEADING_LETTER_SPACING_LARGE = '0.4000px';
export const HIVE_FREE_FLOW_CONTENT_SIZE_SMALLEST = '9px';
export const HIVE_FREE_FLOW_CONTENT_SIZE_SMALL = '12px';
export const HIVE_FREE_FLOW_CONTENT_SIZE_MEDIUM = '14px';
export const HIVE_FREE_FLOW_CONTENT_LETTER_SPACING_MEDIUM = '0px';
export const HIVE_FREE_FLOW_CONTENT_SIZE_LARGE = '16px';
export const HIVE_FREE_FLOW_CONTENT_WEIGHT_REGULAR = '400';
export const HIVE_FREE_FLOW_CONTENT_WEIGHT_SEMIBOLD = '600';
export const HIVE_FREE_FLOW_CONTENT_WEIGHT_BOLD = '700';
export const HIVE_LABEL_SIZE_SMALLEST = '9px';
export const HIVE_LABEL_SIZE_SMALL = '12px';
export const HIVE_LABEL_SIZE_MEDIUM = '14px';
export const HIVE_LABEL_SIZE_LARGE = '16px';
export const HIVE_VALUE_SIZE_SMALL = '12px';
export const HIVE_VALUE_SIZE_MEDIUM = '14px';
export const HIVE_VALUE_SIZE_LARGE = '22px';
export const HIVE_VALUE_SIZE_EXTRA_LARGE = '32px';
export const HIVE_LINK_SIZE_SMALLEST = '9px';
export const HIVE_LINK_SIZE_SMALL = '12px';
export const HIVE_LINK_SIZE_MEDIUM = '14px';
export const HIVE_LINK_SIZE_LARGE = '16px';
export const HIVE_ASSISTIVE_CONTENT_SIZE_SMALLEST = '12px';
export const HIVE_LABEL_WEIGHT_REGULAR = '400';
export const HIVE_LABEL_WEIGHT_SEMIBOLD = '600';
export const HIVE_LABEL_WEIGHT_BOLD = '700';
export const HIVE_VALUE_WEIGHT_REGULAR = '400';
export const HIVE_VALUE_WEIGHT_SEMIBOLD = '600';
export const HIVE_LINK_WEIGHT_REGULAR = '400';
export const HIVE_ASSISTIVE_CONTENT_WEIGHT_REGULAR = '400';
export const HIVE_LABEL_LETTER_SPACING_MEDIUM = '0px';
export const HIVE_VALUE_LETTER_SPACING_MEDIUM = '0px';
export const HIVE_LINK_LETTER_SPACING_MEDIUM = '0px';
export const HIVE_ASSISTIVE_CONTENT_LETTER_SPACING_MEDIUM = '0px';
export const HIVE_FIELD_VALUE_SIZE_SMALL = '12px';
export const HIVE_FIELD_VALUE_LETTER_SPACING_MEDIUM = '0px';
export const HIVE_FIELD_VALUE_DECORATION_REGULAR = 'Regular';
export const HIVE_FIELD_VALUE_DECORATION_ITALIC = 'Italic';
export const HIVE_TEXT_INFO_HOVER = '#0B387A';
export const HIVE_LINK_DEFAULT_HOVER = '#0B387A';
export const HIVE_INTERACTIVECARD_BORDER_SELECTED = '#5A0031';
export const HIVE_INTERACTIVECARD_BORDER_PRESSED = '#5A0031';
export const HIVE_INTERACTIVECARD_BORDER_HOVER = '#A50963';
